import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestArticleinfolist } from "../apiRequests/requestArticleinfolist";
import { requestStep3 } from "../apiRequests/requestStep3";
import { requestStep4 } from "../apiRequests/requestStep4";

// Internal helper for step4 and FrameArticles
const requestRest = ({ apiConfigs, Uterum }) => {
  const {
    FrameArticleErpId,
    FramePrimedArticleErpId,
    FramePrimedAddonArticleErpId,
    FramePaintedArticleErpId,
    FramePaintedAddonArticleErpId
  } = Uterum;

  const responseStep4 = requestStep4({
    apiConfigs,
    data: Uterum,
    onSuccess: (response) => {
      return response;
    },
  });

  const responseArticleinfolist = requestArticleinfolist({
    apiConfigs,
    tentativeData: [
      FrameArticleErpId,
      FramePrimedArticleErpId,
      FramePrimedAddonArticleErpId,
      FramePaintedArticleErpId,
      FramePaintedAddonArticleErpId
    ],
    onSuccess: (response) => {
      return response;
    },
  });

  return Promise.all([responseStep4, responseArticleinfolist]).then(
    ([responseStep4, responseArticleinfolist]) => {
      return {
        data: {
          cgeObj: responseStep4.data,
          FrameArticles: responseArticleinfolist.data,
        },
      };
    }
  );
};

export const requestDesign_Aggregated = createAsyncThunk(
  "thunks/requestDesign_Aggregated",
  async (data = { uterumProperties: null }, thunkAPI) => {
    const state = thunkAPI.getState();
    const { requests, Uterum } = state;
    const { apiConfigs } = requests;

    (!data || Object.keys(data).length === 0) &&
      console.error(
        `Unexpected data in thunks/requestDesign_Aggregated: ${data}`
      );

    Object.keys(data).some(
      (key) =>
        key !== "uterumProperties" &&
        console.error(
          `Unexpected key in thunks/requestDesign_Aggregated: ${key}`
        )
    );

    const { uterumProperties } = data;

    // Atm, currently used in URL on application init at DesignView
    const propertiesFromUrl = [
      "FrameWidth",
      "FrameDepth",
      "FrameAddonWidth",
      "Corners",
      "Color",
    ];

    /* When app is started at DesignView (step 4),
    a request for step 3 is required to receive
    a basic configuration object prior to the 
    request for step 4 */
    const isStep3Required =
      uterumProperties &&
      Object.keys(uterumProperties).some((key) =>
        propertiesFromUrl.includes(key)
      );

    let aggregatedResponse = null;

    if (isStep3Required) {
      // With URL params, e.g. from LFC
      aggregatedResponse = await requestStep3({
        apiConfigs,
        data: {
          ...Uterum,
          ...uterumProperties,
        },
        onSuccess: (response) => {
          const cgeObj = response.data;
          const { Uterum } = cgeObj;

          return requestRest({ apiConfigs, Uterum });
        },
      });
    } else {
      // Default scenario
      aggregatedResponse = await requestRest({
        apiConfigs,
        Uterum,
      });
    }

    return aggregatedResponse.data;
  },
  conditionRuleset
);
